import CommonViewPage from "./CommonViewPage";

export default CommonViewPage;